const formatDate = (value) => {
  if (!value) return "No aplica";

  return new Date(
    `${value}T00:00:00`
  ).toLocaleDateString("es-CO");
};

const getStatusLabel = (status) => {
  const labels = {
    issued: "Pendiente",
    partial_paid: "Pago parcial",
    paid: "Pagada",
    overdue: "Vencida",
    cancelled: "Anulada",
  };

  return labels[status] || status || "Pendiente";
};

export default function InvoiceHeader({
  company,
  invoice,
}) {
  return (
    <header className="invoice-header">
      <div className="invoice-company">
        {company?.logo_url && (
          <img
            src={company.logo_url}
            alt={`Logo ${company.company_name || "empresa"}`}
            className="invoice-logo"
          />
        )}

        <h1>{company?.company_name || "Empresa"}</h1>

        <div className="invoice-company-data">
          <p>
            <strong>NIT:</strong> {company?.nit || "-"}
          </p>

          <p>
            <strong>Correo:</strong> {company?.email || "-"}
          </p>

          <p>
            <strong>Teléfono:</strong> {company?.phone || "-"}
          </p>

          {company?.address && (
            <p>
              <strong>Dirección:</strong> {company.address}
            </p>
          )}
        </div>
      </div>

      <div className="invoice-number">
        <span className="invoice-document-label">
          FACTURA DE VENTA
        </span>

        <h2>{invoice?.number || "-"}</h2>

        <span
          className={`invoice-status invoice-status-${invoice?.status}`}
        >
          {getStatusLabel(invoice?.status)}
        </span>

        <div className="invoice-dates">
          <p>
            <strong>Emisión:</strong>{" "}
            {formatDate(invoice?.issue_date)}
          </p>

          <p>
            <strong>Vencimiento:</strong>{" "}
            {formatDate(invoice?.due_date)}
          </p>
        </div>
      </div>
    </header>
  );
}